// src/components/admin/AdminApplications.jsx
import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';

export default function AdminApplications() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    async function fetch() {
      try {
        // Try submittedAt first, fallback to createdAt
        let snap;
        try {
          snap = await getDocs(query(collection(db, 'job_applications'), orderBy('submittedAt', 'desc')));
        } catch {
          snap = await getDocs(collection(db, 'job_applications'));
        }
        setApps(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetch();
  }, []);

  const formatDate = (app) => {
    const ts = app.submittedAt || app.createdAt;
    if (!ts) return '—';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const filtered = apps.filter(a =>
    !search || [a.name, a.email, a.jobTitle].join(' ').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h2 className="title-4">Job Applications</h2>
          <p className="body-sm" style={{ color: 'var(--token-desc)', marginTop: '4px' }}>{apps.length} total application{apps.length !== 1 ? 's' : ''}</p>
        </div>
        <input
          type="search"
          placeholder="Search by name, email, or job..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="form-input"
          style={{ width: '280px', height: '40px', padding: '8px 16px' }}
        />
      </div>

      {loading ? (
        <div style={{ padding: '48px', textAlign: 'center', color: 'var(--token-desc)' }}>Loading...</div>
      ) : filtered.length === 0 ? (
        <div style={{ padding: '48px', textAlign: 'center', color: 'var(--token-desc)', background: '#fff', borderRadius: '8px' }}>
          {apps.length === 0 ? 'No applications yet.' : 'No results match your search.'}
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Job Title</th>
                <th>Experience</th>
                <th>Date</th>
                <th>Resume</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(app => (
                <tr key={app.id}>
                  <td><strong>{app.name || '—'}</strong></td>
                  <td>
                    <a href={`mailto:${app.email}`} style={{ color: 'var(--primary-500)', textDecoration: 'none' }}>
                      {app.email || '—'}
                    </a>
                  </td>
                  <td>{app.phone || '—'}</td>
                  <td>{app.jobTitle || '—'}</td>
                  <td>{app.experience || '—'}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{formatDate(app)}</td>
                  <td>
                    {app.resumeUrl ? (
                      <a
                        href={app.resumeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline"
                        style={{ padding: '4px 12px', height: 'auto', fontSize: '13px', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                      >
                        ↓ Download
                      </a>
                    ) : (
                      <span style={{ color: 'var(--token-desc)', fontSize: '13px' }}>None</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}